import { createBrowserHistory, History } from 'history'

import { ElasticAdapter } from './adapters/Elastic'
import { SentryAdapter } from './adapters/Sentry'
import { IErrorLogger, HTTPException, severityLevel } from './types'

class ErrorLogger implements IErrorLogger {
  history: History

  constructor(
    private readonly adapters: IErrorLogger[] = [
      new SentryAdapter(),
      new ElasticAdapter(),
    ],
  ) {
    this.history = createBrowserHistory()
    this.getNavigationHistory()
  }

  getNavigationHistory() {
    this.adapters.forEach((logger) => {
      logger.getNavigationHistory(this.history)
    })
  }
  init(): void {
    this.adapters.forEach((logger) => {
      logger.init()
    })
  }

  captureException(
    transactionName: string,
    severityLevel: severityLevel,
    error: Error,
    details: Record<string, any>,
  ): void {
    this.adapters.forEach((logger) => {
      logger.captureException(transactionName, severityLevel, error, details)
    })
  }

  captureLog(
    message: string,
    severityLevel: severityLevel,
    details: Record<string, any>,
  ): void {
    this.adapters.forEach((logger) => {
      logger.captureLog(message, severityLevel, details)
    })
  }

  captureHTTPException(error: HTTPException): void {
    this.adapters.forEach((logger) => {
      logger.captureHTTPException(error)
    })
  }

  captureUIException(error: Error, { componentStack }: any) {
    this.adapters.forEach((logger) => {
      logger.captureUIException(error, { componentStack })
    })
  }
}

export default new ErrorLogger()
